import s from './Contact.module.css';

export default function Contact() {
  return (
    <section id="contact" className={s.section} aria-label="Contact">
      {/* Decorative elements */}
      <div className={s.ring} />
      <div className={s.orbitDot} />
      <div className={s.scan} />
      <div className="noise" />

      <div className={s.inner}>
        <div className={s.eyebrow}>Let's work together</div>

        <h2 className={s.big}>
          Have an idea?<br />
          <em>Let's talk.</em>
        </h2>

        <p className={s.desc}>
          I'm open to <strong>freelance projects</strong>, <strong>partnerships</strong> and{' '}
          <strong>full-time roles</strong>.<br />
          Pick a channel and say hello — I reply within 24 hours.
        </p>

        <div className={s.links}>
          <a href="mailto:yosry@nextitera.com" className={s.link}>
            <span className={s.ico}>✉</span>
            <div className={s.txt}>
              <div className={s.lbl}>Email</div>
              <div className={s.val}>yosry@nextitera.com</div>
            </div>
          </a>
          <a href="https://linkedin.com/in/yosrymlika" target="_blank" rel="noreferrer" className={s.link}>
            <span className={s.ico}>in</span>
            <div className={s.txt}>
              <div className={s.lbl}>LinkedIn</div>
              <div className={s.val}>linkedin.com/in/yosrymlika</div>
            </div>
          </a>
        </div>

        <div className={s.avail}>
          <span className={s.availDot} />
          <span>Currently available · Dubai, UAE · EN / FR / AR</span>
        </div>
      </div>
    </section>
  );
}
